import React from "react";

function Footer(props) {
  return (
    <div className="mpm-footer">
      &copy; MPM 2021 Copyright Tous droits réservés - Version :{" "}
      {process.env.REACT_APP_APPLICATION_VERSION}
    </div>
  );
}

export default Footer;
